<template>
  <div class="rtl pages-navigator">
    <div
      v-tooltip="{ content: this.$t('tooltip.firstPage'), placement: 'right' }"
      class="arrow-icon otz-icon"
      :class="{ disable: isFirstPage }"
      @click.stop="setPage(0)"
      @dblclick.stop
    >
      6
    </div>
    <div
      v-tooltip="{
        content: this.$t('tooltip.prevPage10'),
        placement: 'right',
      }"
      class="arrow-icon otz-icon"
      :class="{ disable: isFirstPage }"
      @click.stop="incPage(-10)"
      @dblclick.stop
    >
      5
    </div>
    <div
      v-tooltip="{ content: this.$t('tooltip.prevPage1'), placement: 'right' }"
      class="arrow-icon otz-icon"
      :class="{ disable: isFirstPage }"
      @click.stop="incPage(-1)"
      @dblclick.stop
    >
      7
    </div>
    <input
      :value="page"
      @keydown.enter="goToPage"
      @wheel="wheeling"
      @focus="selectText($event.target)"
    />
    <span class="text">{{ $t("book.outof") }}</span>
    <span>&nbsp;</span>
    <span class="text">{{ numPages }}</span>
    <div
      v-tooltip="{ content: this.$t('tooltip.nextPage1'), placement: 'right' }"
      class="arrow-icon otz-icon"
      :class="{ disable: isLastPage }"
      @click.stop="incPage(1)"
      @dblclick.stop
    >
      2
    </div>
    <div
      v-tooltip="{
        content: this.$t('tooltip.nextPage10'),
        placement: 'right',
      }"
      class="arrow-icon otz-icon"
      :class="{ disable: isLastPage }"
      @click.stop="incPage(10)"
      @dblclick.stop
    >
      4
    </div>
    <div
      v-tooltip="{ content: this.$t('tooltip.lastPage'), placement: 'right' }"
      class="arrow-icon otz-icon"
      :class="{ disable: isLastPage }"
      @click.stop="setPage(numPages)"
      @dblclick.stop
    >
      3
    </div>
  </div>
</template>

<script>
let t;
import { mapActions } from "vuex";
import { goToPage as go } from "@/services/bookData.js";
export default {
  props: ["numPages", "page", "tabId"],
  computed: {
    isFirstPage() {
      return this.$store.state.tabs[this.tabId].page == 1;
    },
    isLastPage() {
      return this.$store.state.tabs[this.tabId].page == this.numPages;
    },
  },
  methods: {
    ...mapActions("tabsManager", ["incScrollTo"]),
    wheeling(event) {
      clearTimeout(t);
      t = setTimeout(() => {
        let numPages = event.wheelDeltaY / event.wheelDelta;
        if (event.wheelDelta > 0) numPages *= -1;
        this.incPage(numPages);
      }, 20);
    },
    goToPage(event) {
      try {
        let newPage = parseInt(event.srcElement.value);
        newPage = this.validatePage(newPage);
        go(newPage, this.tabId);
      } catch (ex) {
        console.error(ex);
      }
    },
    incPage(num) {
      try {
        let newPage = this.page + num;
        newPage = this.validatePage(newPage);
        go(newPage, this.tabId);
      } catch (ex) {
        console.error(ex);
      }
    },
    setPage(num) {
      try {
        num = this.validatePage(num);
        go(num, this.tabId);
      } catch (ex) {
        console.error(ex);
      }
    },
    validatePage(page) {
      if (page < 1) page = 1;
      if (page > this.numPages) page = this.numPages;
      return page;
    },
    selectText(el) {
      el.select();
    },
  },
};
</script>

<style lang="scss" scoped>
// .pages-navigator {
//   z-index: 9999;
//   width: 170px;
//   height: 30px;
//   /* float: left; */
//   position: absolute;
//   left: 10px;
//   top: 10px;
//   font-size: 18px;
// }

.arrow-icon {
  width: 17px;
  height: 100%;
  margin-right: 3px;

  &:hover:not(.disable) {
    background-color: transparent !important;
    color: #000;
  }
}
.text {
  height: 18px;
  line-height: 20px;
}
</style>
